import React, { Component } from 'react'
import axios from "axios";
import "../css/general-style.css"
import '../css/table-responsive.css'
import { getValueCookie } from '../services/cookieService'
import server from "../services/Connection/backEndLink";
import LoadingWindow from '../components/LoadingWindow';
import Swal from "sweetalert2";
import SmallModal from '../components/SmallModal';
import { MdEdit } from "react-icons/md";
import { IoSearch } from "react-icons/io5";

// Menu
import { Menu } from "../components/Menu/Menu";

export default class SpecialCustomerPricing extends Component {
    constructor(props) {
        super(props)
        this.ModalLoading = React.createRef();
    }

    state = {
        Customers: [],
        FilteredCustomers: [],
        CustomerSelected: [],
        SearchTerm: "",
        showCustomerModal: false,
        showCustomerListModal: false,
        showModal1: false,
        newDiscount: 0,
        searchAddCustomerModal: ""
    }

    componentDidMount(){
        this.getFullCustomerList();
    }

    async getFullCustomerList(){
        let salesPerson = '0000';
        let company = getValueCookie('CompanyId')
        let fullCustomerList
        const payload = {
            data: {
                SalespersonNo: salesPerson,
                idCompany: Number(company)
            }
        }

        const query = "/customer/getList"
        await axios.post(`${server.url}${query}`, payload).then(
            response => {
                fullCustomerList = response.data.data
            }
        ).catch(error => {
            console.log(error)
            // confirmCloseAlert('incorrect', 'Error in the Server Response: ' + error)
        })
        
        const customerList = await this.getSpecialPricingCustomers();
        
        this.matchCustomersWithMissingKeys(fullCustomerList, customerList);
    }
    
    matchCustomersWithMissingKeys(fullCustomerList, specialCustomerList) {
        const specialCustomerNo = new Map(specialCustomerList.map(obj => [obj.customer_no, obj]));
        const allKeys = Array.from(
            fullCustomerList.reduce((keys, obj) => {
                Object.keys(obj).forEach(key => keys.add(key));
                return keys;
            }, new Set())
        );

        // Add keys from specialCustomerList
        specialCustomerList.forEach(obj => {
            Object.keys(obj).forEach(key => allKeys.includes(key) || allKeys.push(key));
        });

        const matches = fullCustomerList
        .filter(obj => specialCustomerNo.has(obj.CustomerNo))
        .map(obj => {
            const special = specialCustomerNo.get(obj.CustomerNo) || {};
            const merged = { ...obj, ...special };
            return {
                ...merged
            }
        })
        this.setState({FilteredCustomers: matches, Customers: fullCustomerList});
    }

    async getSpecialPricingCustomers() {
        let company = getValueCookie('CompanyId')
        const url = server.url
        const payload = {
            data: {
                companyId: Number(company),
                customerNo: "*"
            }
        }

        const query = "/customer/discount";
        return await axios.post(`${url}${query}`, payload).then(
            response =>  response.data.data.data
        ).catch(error => {
            console.log(error)
        })
    }

    
    filterCustomer = () => {
        const { SearchTerm, FilteredCustomers } = this.state;
        const lowerSearch = (SearchTerm || '').toLowerCase();

        const filtered = FilteredCustomers.filter(customer => {
            const customerNo = customer.CustomerNo ? customer.CustomerNo.toLowerCase() : '';
            const customerName = customer.CustomerName ? customer.CustomerName.toLowerCase() : '';

            return customerNo.includes(lowerSearch) || customerName.includes(lowerSearch);
        });

        this.setState({ FilteredCustomers: filtered });
    }

    // Handles to handle the button events

    handleSearchChange = (e) => {
        this.setState({ SearchTerm: e.target.value });
    }

    handlePercentChange = (e) => {
        const value = e.target.value;
        this.setState(prevState => ({
            newDiscount: value,
            CustomerSelected: {
                ...prevState.CustomerSelected,
                discount_percent: value
            }
        }));
    }

    handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            this.filterCustomer();
        }
    }

    handleSearchButtonClick = () => {
        this.filterCustomer();
    }

    handleShowCustomer = (customer) => {
        this.setState({
            CustomerSelected: customer,
            showCustomerModal: true
        });
    }
    
    handleModalOpen = (modal, customer = null) => {
        this.setState(prevState => ({
            [modal]: true,
            customerSelected: customer || prevState.CustomerSelected
        }));
    }

    handleModalClose = (modal) => {
        this.setState({ [modal]: false })
    }

    confirmUpdatePercent = () => {
        Swal.fire({
            title: 'Do you want to continue?',
            text: 'The unit prices for this customer will be adjusted based on their assigned price level.',
            showDenyButton: true,
            confirmButtonText: 'Yes',
            denyButtonText: `No`,
            allowOutsideClick: false
        }).then(async (result) => {
            if (result.isConfirmed) {
                this.handleModalClose('showCustomerModal')
                this.handleModalClose('showCustomerListModal')
                // Call the API to update the customer discount percent
                const { CustomerSelected, newDiscount } = this.state;
                const apiResult = await this.updateCustomerDiscountPercent(CustomerSelected.CustomerNo, newDiscount || CustomerSelected.discount_percent );
                if (apiResult) {
                    // Update the state with the new discount percent
                    this.getFullCustomerList();

                    this.setState({ newDiscount: 0 });
                    Swal.fire('Success', 'Customer discount percent updated successfully!', 'success');
                } else {
                    Swal.fire('Error', 'Failed to update customer discount percent.', 'error');
                }
            }
        })
    }
    
    confirmDismissCustomer = () => {
        Swal.fire({
            title: 'Do you want to dismiss this customer?',
            showDenyButton: true,
            confirmButtonText: 'Yes',
            denyButtonText: `No`,
            allowOutsideClick: false
        }).then(async (result) => {
            if (result.isConfirmed) {
                this.toggleCustomer(this.state.CustomerSelected.CustomerNo).then((response) => {
                    const { FilteredCustomers } = this.state;
                    if (response && response.status === 'success') {
                        Swal.fire('Success', 'Customer has been dismissed successfully!', 'success');
                        const updatedCustomers = FilteredCustomers.map(customer => {
                            if (customer.CustomerNo === this.state.CustomerSelected.CustomerNo) {
                                return { ...customer, active: response.newStatus }; // Set active to 0 for dismissed customer
                            }
                            return customer;
                        })
                        // Update both Customers and FilteredCustomers arrays for consistency
                        const updatedAllCustomers = this.state.Customers.map(customer => {
                            if (customer.CustomerNo === this.state.CustomerSelected.CustomerNo) {
                                return { ...customer, active: 0 };
                            }
                            return customer;
                        });
                        this.setState({
                            CustomerSelected: { ...this.state.CustomerSelected, active: 0 },
                            Customers: updatedAllCustomers,
                            FilteredCustomers: updatedCustomers,
                            showCustomerModal: false
                        });
                    } else {
                        Swal.fire('Error', 'Failed to dismiss customer.', 'error');
                    }
                }).catch(error => {
                    console.error('Error dismissing customer:', error);
                });
            }
        })
    }

    confirmAddCustomer = (customer) => {
        Swal.fire({
            title: 'Do you want to add this customer?',
            showDenyButton: true,
            confirmButtonText: 'Yes',
            denyButtonText: `No`,
            allowOutsideClick: false
        }).then(async (result) => {
            if (result.isConfirmed) {
                this.handleModalClose('showCustomerListModal');
                // Call the API to add the customer

            }
        })
    }

    // Fucntions for Customer Modal

    // Update customer special discount
    updateCustomerDiscountPercent = async (customerNo, discount) => {
        let company = getValueCookie('CompanyId');
        const payload = {
            data: {
                companyId: Number(company),
                customerNo,
                discount
            }
        };
        const url = `${server.url}/customer/upsert-discount`;
        try {
            const response = await axios.post(url, payload);
            return response.data;
        } catch (error) {
            console.log(error);
            return null;
        }
    }

    // Update customer status
    toggleCustomer = async (customerNo) => {
        let company = getValueCookie('CompanyId');
        const payload = {
            data: {
                companyId: Number(company),
                customerNo,
            }
        };
        const url = `${server.url}/customer/toggle-discount`;
        try {
            const response = await axios.post(url, payload);
            return response.data;
        } catch (error) {
            console.log(error);
            return null;
        }
    }

    // Functions for Add customer modal
    handleSearchAddCustomer = (e) => {
        this.setState({ searchAddCustomerModal: e.target.value.toLowerCase() })
    }

    // Search the customer by the No or name
    getFilterAddCustomerModal() {
        const { Customers, searchAddCustomerModal } = this.state;
        return Customers.filter((customer) => customer.CustomerName.toLowerCase().includes(searchAddCustomerModal));
    }

    // Show the results of the search
    getVisibleAddCustomerModal() {
        const { Customers, searchAddCustomerModal } = this.state;

        if (searchAddCustomerModal) {
            return this.getFilterAddCustomerModal();
        } else {
            return Customers.slice(0,20);
        }
    }

    render() {
        let { SearchTerm, FilteredCustomers, CustomerSelected, searchAddCustomerModal, newDiscount } = this.state;
        FilteredCustomers = this.state.FilteredCustomers.slice(0, 20);
        const visibleCustomers = this.getVisibleAddCustomerModal();
        return (
            <div>
                {/* Main menu */}
                <Menu Refresh={this.state.Refresh} Father={this} />
                <LoadingWindow ref={this.ModalLoading} />
                <div className='text-center my-4'>
                    <h2 className='display-4 fw-bold inventory-title'>Special Customer list</h2>
                </div>
                <div className=' col-sm-12 d-flex justify-content-end'>
                    <div className='me-4'>
                        <button className="btn greenButton" onClick={() => this.handleModalOpen('showCustomerListModal')}>Add Customer</button>
                    </div>
                </div>
                <div className=' col-sm-12 row d-flex justify-content-center'>
                    <div className='col-4'>
                        <input className='form-control display-inline' placeholder='Search customer' autoComplete="off" value={SearchTerm} onChange={this.handleSearchChange} onKeyDown={this.handleKeyPress} />
                    </div>
                    <div className='col-auto'>
                        <button className="btn blueButton" onClick={this.handleSearchButtonClick}><IoSearch /></button>
                    </div>
                </div>
                <div className='row pb-2'>
                    <div className='col-sm-12'>
                        <div className='tableFixHead tb-1'>
                            <table className='table table-striped align-middle table-hover'>
                                <thead>
                                    <tr className='text-center'>
                                        <th>
                                            <div className='d-flex justify-content-center align-items-center'>
                                                Customer No
                                            </div>
                                        </th>
                                        <th>
                                            <div className='d-flex justify-content-center align-items-center'>
                                                Name
                                            </div>
                                        </th>
                                        <th>
                                            <div className='d-flex justify-content-center align-items-center'>
                                                Address Line
                                            </div>
                                        </th>
                                        <th>
                                            <div className='d-flex justify-content-center align-items-center'>
                                                City
                                            </div>
                                        </th>
                                        <th>
                                            <div className='d-flex justify-content-center align-items-center'>
                                                Price Level
                                            </div>
                                        </th>
                                        <th>
                                            <div className='d-flex justify-content-center align-items-center'>
                                                Percent
                                            </div>
                                        </th>
                                        <th>
                                            <div className='d-flex justify-content-center align-items-center'>
                                                Status
                                            </div>
                                        </th>
                                        <th>
                                            <div className='d-flex justify-content-center align-items-center'>
                                                Actions
                                            </div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        FilteredCustomers.map((customer, i) => (
                                            <tr className='text-center'key={i}>
                                                <td>{customer.CustomerNo}</td>
                                                <td>{customer.CustomerName}</td>
                                                <td>{customer.AddressLine1}</td>
                                                <td>{customer.City}</td>
                                                <td>{customer.PriceLevel}</td>
                                                <td>{customer.discount_percent || 0}%</td>
                                                <td>
                                                    {customer.active === 1
                                                    ? <span className="badge rounded-pill badge-success">Active</span>
                                                    : <span className="badge rounded-pill badge-secondary">Inactive</span>
                                                    }
                                                </td>
                                                <td><button className='btn blueButton' onClick={() => this.handleShowCustomer(customer)}><MdEdit /></button></td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                {/* Modal to add new Customer */}
                <SmallModal title="Add New Customer" size="xl" show={this.state.showCustomerListModal} close={(modal = "showCustomerListModal") => this.handleModalClose(modal)}>
                    <div className='row pt-2'>
                        <div className=' col-sm-12 row d-flex justify-content-center'>
                            <div className='col-4'>
                                <input className='form-control display-inline' placeholder='Search customer' value={searchAddCustomerModal} onChange={this.handleSearchAddCustomer} />
                            </div>
                            <div className='col-auto'>
                                <button className="btn blueButton" onClick={this.handleSearchButtonClick}><IoSearch /></button>
                            </div>
                        </div>
                        <div className='col-sm-12 tableFixHead'>
                            <table className='table table-hover text-center'>
                                <thead className='thead'>
                                    <tr className='text-center'>
                                        <th>Customer No</th>
                                        <th>Customer Name</th>
                                        <th>Sales Person</th>
                                        <th>Address Line</th>
                                        <th>City</th>
                                        <th>State</th>
                                        <th>Zip Code</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {visibleCustomers.map((element, e) => (
                                            <tr className='text-center' key={e}>
                                                <td>{element.CustomerNo}</td>
                                                <td>{element.CustomerName}</td>
                                                <td>{element.SalespersonNo}</td>
                                                <td>{element.AddressLine1}</td>
                                                <td>{element.City}</td>
                                                <td>{element.State}</td>
                                                <td>{element.ZipCode}</td>
                                                <td><button className='btn greenButton' onClick={() => this.handleShowCustomer(element)}>Add</button></td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>
                        <div className='col-sm-12 d-flex justify-content-center pt-2'>
                                <div className="col-6 d-grid gap-2">
                                    <button type="button" onClick={() => this.handleModalClose("showModal1")} className="btn redButton btn-lg">Close</button>
                                </div>
                        </div>
                    </div>
                </SmallModal>
                {/* Show customer modal */}
                <SmallModal title="Update Percent" show={this.state.showCustomerModal} close={(modal = "showCustomerModal") => this.handleModalClose(modal)}>
                    <div className='pt-2 text-center'>
                        <div className='col-sm-12 pb-4'>
                            <h2>{CustomerSelected.CustomerName}</h2>
                            <h5><span className="badge bg-primary">{CustomerSelected.CustomerNo}</span></h5>
                        </div>
                        <div className='g-3 align-items-center'>
                            <div className="form-floating">
                                <input id="inputDiscount" type="number" value={CustomerSelected.discount_percent} className="form-control" onChange={this.handlePercentChange}/>
                                <label htmlFor="inputDiscount">Discount Percent</label>
                            </div>
                        </div>
                        <div className='align-items-center mt-5 row'>
                            <div className='col-sm-6'>
                                { typeof this.state.CustomerSelected.active === 'number' ? (
                                    this.state.CustomerSelected.active === 1 ? (
                                        <button className='btn redButton' onClick={() => this.confirmDismissCustomer()}>Dismiss Customer</button>
                                    ) : (
                                        <button className='btn blueButton' onClick={() => this.confirmDismissCustomer()}>Activate Customer</button>
                                    )
                                ): null}
                            </div>
                            <div className='col-sm-6'>
                                <button disabled={newDiscount === 0} className='btn greenButton' onClick={() => this.confirmUpdatePercent()}>Save Changes</button>
                            </div>
                        </div>
                    </div>
                </SmallModal>
            </div>
        )
    }
}